module.exports = __webpack_public_path__ + "static/media/locations-icon.9bad2ef5.svg";